<template>
  <div>
  <!-- Hero section -->
  <section class="relative overflow-hidden bg-[radial-gradient(circle_at_center,theme(colors.slate.700),theme(colors.slate.900))] text-slate-50">
    <div class="mx-auto mt-20 flex max-w-6xl flex-col gap-10 px-6 py-12 md:flex-row md:items-center md:py-16 lg:py-20">
      <!-- Left column -->
      <div class="md:w-1/2 space-y-6">
        <div class="space-y-3">
          <h1 class="text-3xl font-semibold sm:text-4xl lg:text-5xl text-slate-100 lg:leading-[1.2]">
            {{ $t('caseStudies.CS_AIUX-process.title') }}
          </h1>
          <p class="max-w-xl text-md text-slate-100 sm:text-base lg:text-lg">
            {{ $t('caseStudies.CS_AIUX-process.title_description') }}
          </p>
        </div>

        <!-- Tags -->
        <div class="flex flex-wrap gap-2 md:gap-4 pt-2">
          <span v-for="(tag, idx) in $tm('caseStudies.CS_AIUX-process.tags')" :key="idx" 
          class="inline-flex items-center rounded-full border border-slate-400 px-3 py-1 text-xs font-medium uppercase tracking-wide text-slate-300">
            {{tag}}
          </span>
        </div>
      </div>

      <!-- Right column -->
      <div class="md:w-1/2 flex justify-center hidden md:block">
        <img 
        :src="imgSrc($t('caseStudies.CS_AIUX-process.heroImage'))" 
        :alt="$t('caseStudies.CS_AIUX-process.heroImage_alt')" 
        class="max-w-[350px]"/>
      </div>
    </div>
  </section>
  <!-- End of Hero section -->


  <!-- intro-section -->
  <section class="flex flex-col text-normal leading-normal mx-auto max-w-6xl px-6 py-8 dark:text-white">
    <ul class="list-none flex flex-row flex-wrap items-end justify-start gap-8 text-xl dark:text-white h-auto">
      <!-- Role detail -->
      <li class="flex flex-col text-slashdark dark:text-white">
        <span class="text-lg">{{$t('caseStudies.CS_AIUX-process.myRole.title')}}</span> 
        <span class="font-bold">{{$t('caseStudies.CS_AIUX-process.myRole.description')}}</span> 
      </li>
    </ul>
    <p class="text-slashdark font-light text-xl leading-normal py-4 lg:text-2xl lg:leading-normal dark:text-white">{{$t('caseStudies.CS_AIUX-process.intro-section')}}</p>
  </section>
  <!-- End/intro-section -->

  <!-- How-section -->
  <section class="flex flex-col text-base leading-normal mx-auto max-w-6xl px-6 dark:slate-500 space-y-4">
    <h2 class="text-2xl h-auto max-w-prose dark:text-white">{{$t('caseStudies.CS_AIUX-process.how-section.title')}}</h2>
    <p class="mb-4 text-base text-slate-700 leading-relaxed dark:text-slate-300">{{$t('caseStudies.CS_AIUX-process.how-section.content')}}</p>

    <div class="grid gap-4 sm:grid-cols-3 py-2">
      <div 
      v-for="(area,idx) in $tm('caseStudies.CS_AIUX-process.how-section.areas')" :key="idx" 
      class="rounded-xl border border-slate-300 p-4 space-y-2 justify-start items-start flex flex-col">
    
        <span class="flex h-6 w-6 items-center justify-center rounded-md bg-slate-200 text-sm text-slashgray font-semibold">{{area.number}}</span>
        <h3 class="text-lg font-medium text-slate-600 dark:text-slate-300">
          {{area.title}}
        </h3>

        <p class="text-sm text-slate-700 dark:text-slate-400">
          {{area.description}}
        </p>
      </div>
    </div>

  </section>
  <!-- End/How-section-->

  <!-- What-happened -->
  <section class="flex flex-col text-base leading-normal mx-auto max-w-6xl px-6 dark:slate-500 space-y-4 pt-8">
    <h2 class="text-2xl h-auto max-w-prose dark:text-white">What happened?</h2>
    <p class="mb-4 text-base text-slate-700 leading-relaxed dark:text-slate-300">Using the AI as strategic tool and <b>working backwards from an user anecodte</b>, I managed to create synthetic user, simulate user interviews, product storyboards and an execute a prototype to evaluate the concept in one single day. Althought, these are not final products and need validation in real scenarios are still useful to iterate save times during product definition.</p>

    <div class="grid gap-4 sm:grid-cols-3 py-2">
      <div class="rounded-xl border border-slate-300 p-4 space-y-2 justify-start items-start flex flex-col">
          <h3 class="text-lg font-medium text-slate-600 dark:text-slate-300">Synthetic user</h3>
              <imageLauncherVue
                :src="assetImages[0].src"
                :alt="assetImages[0].alt"
                :startIndex="0"
                :images="assetImages"
                :shadowClass="'shadow-sm transition-shadow duration-200 hover:shadow-lg'"
                class=""
              />
      </div>
      <div class="rounded-xl border border-slate-300 p-4 space-y-2 justify-start items-start flex flex-col">
          <h3 class="text-lg font-medium text-slate-600 dark:text-slate-300">Storyboard</h3>
          <a href=""></a>
              <imageLauncherVue
                :src="assetImages[1].src"
                :alt="assetImages[1].alt"
                :startIndex="1"
                :images="assetImages"
                :shadowClass="'shadow-sm transition-shadow duration-200 hover:shadow-lg'"
                class=""
              />
      </div>
      <div class="rounded-xl border border-slate-300 p-4 space-y-2 justify-start items-start flex flex-col">
        <h3 class="text-lg font-medium text-slate-600 dark:text-slate-300">Prototype</h3>
        <a href="https://brave-shield-47656061.figma.site/" target="_blank" role="button">
          <img 
            :src="imgSrc('assets/work-gallery/CS-AIUX-process/CS_AIUX_prototype_thumbnail.png')" 
            alt="Prototype thumbnail showcasing the main screens of the prototype" 
            class="cursor-pointer transition-transform duration-300 ease-out hover:scale-[1.02]">
        </a>
      </div>
    </div>

  </section>
  <!-- END/Wha-happened -->

  <!-- AIUX-process-section -->
  <section class="flex flex-col text-base leading-normal mx-auto max-w-6xl py-12 px-6 dark:text-white space-y-4">
    <h2 class="text-2xl h-auto max-w-prose ext-slate-700 dark:text-slate-300">{{$t('caseStudies.CS_AIUX-process.framework-section.title')}}</h2>
    <p class="mb-4 text-base text-slate-700 leading-relaxed dark:text-slate-300" v-html="$t('caseStudies.CS_AIUX-process.framework-section.content')"></p>
    <p class="text-xs text-gray-600 leading-relaxed dark:text-slate-300">
      All the AI answers have been reduced to optimize the showcasing. See the full disclosure answers 
      <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> here (FigJam)
      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" /></a>.</p>

    <!-- RESEARCH BLOCK -->
    <div class="space-y-4 p-6 border border-indigo-900/30 rounded-xl dark:border-slate-700">
      <h3 class="text-xl mb-6 text-slate-700 dark:text-slate-300">Research (10 steps)</h3>
      <div class="space-y-2">
        
        <!-- step 01 -->
        <ExpanderStep :step="'01'" :title="'From the user anecdote'" :icon="'🤖'" >
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-3 text-slate-700 text-lg">As starting point, I'm working backwards from the user needs. For this example I'm asking about corporative person and its learning needs.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>I'm looking to understand corporate executive business needs when it comes to learning new skills. What do you know about their ways of learning and preferences?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Executive Learning Preferences & NeedsCorporate executives</p>
                  <p>Corporate executives have distinct learning needs and preferences shaped by their demanding schedules and strategic responsibilities. Here's what research and industry insights tell us:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Micro-learning: Executives prefer bite-sized content (5-15 minutes) they can consume between meetings</li>
                    <li>Just-in-time learning: They want immediate access to relevant knowledge when facing specific challenges</li>
                    <li>Mobile-first: Learning on-the-go via smartphones/tablets during travel or downtime</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 01 -->

        <!-- step 02 -->
        <ExpanderStep :step="'02'" :title="'Narrow problem space'" :icon="'🤖'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">By narrowing the scope I focus in one single solution that helps the AI to contextualize better.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>I’m more interested on corporative executive needs in relation to Micro-learning formats when it comes to learning new skills. Can you expand on this topic?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Executive Needs for Microlearning</p>
                  <p>Executives are increasingly turning to microlearning for skill development due to its alignment with their unique constraints and preferences:</p>
                  <p class="font-semibold">Time Efficiency Imperatives</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>5-15 minute modules that fit between meetings or during brief downtimes</li>
                    <li>Learning in transit, consumable during commutes, flights, or waiting periods</li>
                    <li>No-commitment entry points allowing immediate start/stop without losing progress</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 02 -->

        <!-- step 03 -->
        <ExpanderStep :step="'03'" :title="'Check sources of information'" :icon="'🤖'"> 
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I'm asking the AI from where is getting all this information so I can have a check myself and make sure the suggestions are connected to real information.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you point me to some research that was done for executive business needs when it comes to learn new skills?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                <p class="font-semibold">Academic Research</p>
                  <p>Here are key research sources examining executive learning preferences and microlearning effectiveness for senior leaders:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Harvard Business Review (2019). "The Future of Leadership Development" by Mihnea Moldoveanu and Das Narayandas examines how executive education is evolving toward more personalized, just-in-time learning formats</li>
                    <li>McKinsey Quarterly (2021). "The CEO's new technology agenda" research showing 70% of executives prefer microlearning formats for technology upskilling</li>
                    <li>Center for Creative Leadership. Longitudinal research on "The 70-20-10 Model for Learning and Development" showing executives learn primarily through experience (70%), relationships (20%), and formal training (10%)</li>

                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 03 -->

        <!-- step 04 -->
        <ExpanderStep :step="'04'" :title="'Analyse other products (market research)'" :icon="'🤖'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">The objective of this step is to contextualize the AI and layout the road for next steps.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Are there other apps that are helping corporative executive people to learn through micro-learnings?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Microlearning Apps for Corporate Executives</p>
                  <p>Several platforms have emerged specifically targeting executive learning through microlearning approaches:</p>
                  <p class="font-semibold">Executive-Focused Platforms</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>ExecOnline: Partners with top business schools (Columbia, Yale, Berkeley) to deliver microlearning modules specifically for executives, with applied learning projects</li>
                    <li>Tigerhal: "Knowledge from the world's most successful people" offering 15-minute podcast-style insights from C-suite leaders across industries</li>
                    <li>Blinkist for Business: 15-minute book summaries with special enterprise offering for executive teams</li>
                    <li>MasterClass for Business: Short-form lessons from world-class leaders, with dedicated business content</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 04 -->

        <!-- step 05 -->
        <ExpanderStep :step="'05'" :title="'Strengths-weakness  (market research)'" :icon="'🤖'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">The objective of this step is to contextualize the AI and layout the road for next steps.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>From all these apps you listed, what are their strong points and weak points based on customer reviews?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Executive Microlearning Apps: Strengths & Weaknesses from Reviews</p>
                  <p>Several platforms have emerged specifically targeting executive learning through microlearning approaches:</p>
                  <p class="font-semibold">ExecOnline</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>
                      Strengths:
                      <ul class="list-disc list-outside ml-5">
                        <li>High-quality content from elite business schools</li>
                        <li>Applied learning projects with measurable ROI</li>
                        <li>Strong networking component with peer executives</li>
                      </ul>
                    </li>
                    <li>
                      Weaknesses:
                      <ul class="list-disc list-outside ml-5">
                        <li>Higher price point than most alternatives</li>
                        <li>Some users report platform navigation issues</li>
                        <li>Time commitment still substantial compared to other microlearning options</li>
                      </ul>
                    </li>
                  </ul>
                    <p class="font-semibold">Tigerhall</p>
                  <ul class="list-disc list-outside ml-5">
                      <li>Strengths:
                        <ul class="list-disc list-outside ml-5">
                          <li>Authentic insights from practicing C-suite leaders</li>
                          <li>Location-specific content for regional executives</li>
                          <li>Strong mobile experience with offline capabilities</li>
                        </ul>
                      </li>
                      <li>Weaknesses:
                        <ul class="list-disc list-outside ml-5">
                          <li>Content library still growing, less comprehensive</li>
                          <li>Limited interactive/assessment components</li>
                          <li>Some users report inconsistent content quality</li>
                        </ul>
                      </li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 06 -->

        <!-- step 06 -->
        <ExpanderStep :step="'06'" :title="'Ideal persona'" :icon="'🧑‍🏫'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">With the AI contextualized in user needs and other products out there, I ask to create an ideal persona that fits in this space.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you imagine the ideal persona for a learning platform app?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Ideal Executive Learner Persona: Meet Sarah Chen, Chief Strategy Officer</p>
                  <p>Meet Sarah Chen, Chief Strategy Officer</p>
                  <p class="font-semibold">Demographics:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>MBA from a top-tier business school</li>
                    <li>20+ years of professional experience</li>
                    <li>Manages a team of 12 direct reports</li>
                    <li>MasterClass for Business: Short-form lessons from world-class leaders, with dedicated business content</li>
                  </ul>
               <p class="font-semibold">Daily Reality:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Calendar booked with 8-10 meetings daily</li>
                    <li>60+ minutes of commuting time</li>
                    <li>Travels for business 5-7 days monthly</li>
                    <li>Balances work with family responsibilities</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 06 -->

        <!-- step 07 -->
        <ExpanderStep :step="'07'" :title="'Interview script'" :icon="'📝'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I ask the AI to generate a interview script based on the ideal persona generated at the previous step.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you create an interview script based on Sarah Chen learning needs?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Interview Script: Sarah Chen's Learning Experience</p>
                  <p>Interviewer: Thank you for joining us today, Sarah. As a CSO in the logistics sector:</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li>Wow do you approach learning given your demanding schedule?</li>
                    <li>What specific challenges are you looking to address through your learning efforts?</li>
                    <li>How do you determine what's worth your limited learning time?</li>
                    <li>What formats work best given your constraints?</li>
                    <li>How do you measure the impact of your learning?</li>
                    <li>What's missing from current executive learning options?</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 07 -->

        <!-- step 08 -->
        <ExpanderStep :step="'08'" :title="'Simulate interview'" :icon="'🎙️'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">Generated AI user conversations cannot replace real users conversations but gives you a good starting point. <b>If is possible, have always conversations with real users.</b></p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you turn the interview in an actual conversation with Sarah?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">A conversation with Sarah Chen</p>
                  <p><span class="font-semibold">Interviewer</span> Sarah, thanks for making time in your packed schedule. I'm curious—how do you approach professional learning with all your responsibilities as CSO?</p>
                  <p><span class="font-semibold">Sarah:</span> (<i>laughs</i>) Well, necessity is the mother of invention, right? I've had to become ruthlessly efficient. I used to feel guilty about not completing lengthy courses, but I've realized that's just not how executives can or should learn.</p>
                  <p><span class="font-semibold">Interviewer:</span> What does that look like in practice?</p>
                  <p><span class="font-semibold">Sarah:</span> My learning happens in what I call "micro-moments"—15 minutes between meetings, the Uber ride to the airport, waiting for my daughter's soccer practice to end. I need content designed for these fragments of time that still delivers substantial insights.</p>
                  <p><span class="font-semibold">Interviewer:</span> And what are you trying to learn right now?</p>
                  <p><span class="font-semibold">Sarah:</span> Three main areas keep me up at night. First, how AI is reshaping logistics—not the theoretical possibilities, but practical applications that are working now. Second, navigating the new sustainability regulations affecting our global operations. And third, how to develop my team's strategic thinking when they're drowning in operational demands.</p>

                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 08 -->

        <!-- step 09 -->
        <ExpanderStep :step="'09'" :title="'Data synthesis'" :icon="'🤖'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I retro-feed the AI with its own information to create data insights.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Using data gathered in the interview, what are the main problems for Sara Chen when comes to learning?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Sarah Chen's Key Learning Challenges</p>
                
                  <p><span class="font-semibold">Time Fragmentation.</span><br>Sarah can only learn in "micro-moments" between meetings, during commutes, or in other brief windows throughout her day. Traditional learning formats don't accommodate this fragmented availability.</p>
    
                  <p><span class="font-semibold">Content Discovery Inefficiency.</span><br> She spends more time searching for relevant content than actually learning, noting: "I end up spending more time searching than learning." This search friction significantly reduces her learning ROI.</p>
                  <p><span class="font-semibold">Relevance Filtering</span>. Sarah struggles to quickly identify content that addresses her specific executive challenges in logistics, particularly regarding AI applications, sustainability regulations, and team development.</p>
                  <p><span class="font-semibold">Practical Application Gap</span>. She needs learning that bridges directly to application—content that can be implemented within hours, not days or weeks. Theoretical knowledge without clear application paths provides little value.</p>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 09 -->

        <!-- step 10 -->
        <ExpanderStep :step="'10'" :title="'Problem statement'" :icon="'📌'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I retro-feed the AI with its own information to create data insights.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Using data gathered in the interview, what are the main problems for Sara Chen when comes to learning?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-indigo-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Problem Statement</p>
                  <p>Executive leaders like Sarah Chen need a learning solution that delivers substantive, immediately applicable insights within the fragmented micro-moments of their day, eliminating the inefficient search for relevant content and connecting them with valuable peer experiences—because their current options force an impossible choice between depth and time efficiency, leaving them unable to effectively address their most pressing business challenges through continuous learning.</p>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-indigo-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 10 -->
      </div>
    </div>
    <!-- END RESEARCH BLOCK -->

    <!-- IDEATION BLOCK -->
    <div class="space-y-4 p-6 border border-orange-300 rounded-xl dark:border-orange-100/40">
      <h3 class="text-xl mb-6 text-slate-700 dark:text-slate-300">Ideation(6 steps)</h3>
      <div class="space-y-2">
        
        <!-- step 01 -->
        <ExpanderStep :step="'01'" :title="'How might we’s'" :icon="'🤖'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'" >
          <div class="space-y-6">
            <p class="border-b border-orange-200/70 pb-3 text-slate-700 text-lg">Using the problem statement to generate the How might we questions that will lead me to actual user stories.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Based on this problem statement, can you generate How might we’s?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">How Might We - Questions</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li>How might we deliver substantive learning experiences that fit within the 5-15 minute micro-moments available in an executive's day? </li>
                    <li>How might we eliminate content discovery friction so executives spend more time learning and less time searching?</li>
                    <li>How might we ensure learning content bridges directly to immediate application in real business situations?</li>
                    <li>How might we connect executives with relevant peer insights and experiences without requiring additional time commitments?</li>
                    <li>How might we provide depth of insight without demanding length of engagement?</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center justify-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 01 -->

        <!-- step 02 -->
        <ExpanderStep :step="'02'" :title="'User stories'" :icon="'🤖'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'">
          <div class="space-y-6">
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Transform "How might we's" into user stories</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">User Stories</p>
                  <p>Executives are increasingly turning to microlearning for skill development due to its alignment with their unique constraints and preferences:</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li><span class="font-semibold">As an executive leader</span>, I want to access substantive learning content in 5-15 minute segments, so I can develop new skills during the brief windows available in my schedule.</li>
                    <li><span class="font-semibold">As an executive leader</span>, I want learning content to be instantly discoverable based on my current challenges, so I don't waste valuable time searching instead of learning.</li>
                    <li><span class="font-semibold">As an executive leader</span>, I want to immediately apply what I've learned to my current business situations, so I can see tangible value from my learning investment.</li>
                    <li><span class="font-semibold">As an executive leader</span>, I want to learn from peers who have solved similar challenges, so I can benefit from their experience without scheduling additional meetings.</li>
                    <li><span class="font-semibold">As an executive leader</span>, I want deep insights delivered efficiently, so I don't have to choose between quality and time constraints.</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 02 -->

        <!-- step 03 -->
        <ExpanderStep :step="'03'" :title="'Ideation / brainstorming'" :icon="'🤖'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'"> 
          <div class="space-y-6">
            <p class="border-b border-orange-200/70 pb-2 text-slate-700 text-lg">I'm starting a brainstorming by feeding the AI the user stories and asking it to create conceptual products.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>What are some ideas for a product, like desktop app, that would address these user needs and stories</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Insight Moments" Desktop & Mobile App</p>
                  <p>An intelligent learning companion that lives in your workflow and delivers precisely timed learning interventions.</p>
                  <p>Key Features:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Calendar-Aware Learning</li>
                    <li>Desktop Sidebar</li>
                    <li>Meeting Prep Mode</li>
                    <li>Cross-Device Timeline</li>
                  </ul>
                  <hr class="border-t border-orange-300/70" />
                  <p class="font-semibold">"ExecKnow" Browser Extension & Mobile App</p>
                  <p>A browser extension that transforms idle moments into learning opportunities and connects to a mobile companion.</p>
                  <p>Key Features:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Smart Tab Replacement: Converts new browser tabs into personalized micro-learning moments</li>
                    <li>Meeting Buffer Learning: Detects when you join virtual meetings early and offers quick insights</li>
                    <li>Email Waiting Detection: Provides learning during email loading or sending delays</li>
                    <li>Wisdom Walls: Replaces standard loading screens with relevant executive insights</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 03 -->

        <!-- step 04 -->
        <ExpanderStep :step="'04'" :title="'Ideation / narrow focus'" :icon="'🤖'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I'm focus in one single concept that the AI has produced. This helps to stay on track and don't get too wide.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Could you expand the “Insight Moments” idea?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">"Insight Moments" - Detailed Concept</p>
                  <p>"Insight Moments" transforms the fragmented time in an executive's day into powerful learning opportunities through an intelligent system that delivers precisely what's needed, exactly when it's needed.</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Personal Insight Feed: Curated 5-minute learning modules based on your role, industry, and current challenges</li>
                    <li>Priority Topics: Executive selects 3-5 focus areas (e.g., "AI in logistics," "team development") for targeted content</li>
                    <li>Learning Momentum: Visual representation of learning consistency rather than traditional completion metrics</li>
                    <li>Impact Tracker: Simple way to flag when insights influenced decisions or discussions</li>
                    <li>Pre-Meeting Primers: 3-minute briefings delivered 10 minutes before relevant meetings</li>
                    <li>Travel Mode: Detects when you're in transit and offers audio-optimized conten</li>
                    <li>Focus Windows: Identifies calendar gaps over 15 minutes and suggests deeper learning opportunities</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 04 -->

        <!-- step 05 -->
        <ExpanderStep :step="'05'" :title="'Ideas into Features'" :icon="'🛠️'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I'm asking the AI to trasform the product details into actual features to be used later on prototyping.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you translate these idea into features?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">"Insight Moments" Features</p>
                     <ul class="list-decimal list-outside ml-5">
                        <li>Smart Timing Engine: Algorithm that identifies optimal learning moments based on calendar analysis and user behavior patterns</li>
                        <li>Context Matcher: Delivers content relevant to upcoming meetings, active projects, and recent work topics</li>
                        <li>Format Shifter: Automatically converts content between text, audio, and visual formats based on detected user context</li>
                        <li>Micro-Session Scheduler: Suggests and books 5-15 minute learning sessions during identified calendar gaps</li>
                        <li>Priority Topic Manager: Interface for executives to select and rank 3-5 focus areas for targeted content</li>
                        <li>Learning Style Detector: Analyzes engagement patterns to determine optimal content formats and complexity</li>
                        <li>Industry Vertical Filter: Ensures all content is relevant to the executive's specific industry challenges</li>
                        <li>Expertise Recognition: Calibrates content depth based on detected knowledge level in each topic area</li>
                      </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 06 -->

        <!-- step 06 -->
        <ExpanderStep :step="'06'" :title="'Benchmark / features'" :icon="'📊'" :style="'border-orange-300 bg-orange-200 hover:bg-orange-300'" :background="'bg-orange-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">I'm ending the ideation process by asking the AI to compare these features with ther apps in the market. Benchmarking is a early way of validate the options.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>From the features you mentioned, which one are more important that differentiate from our competitors?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-orange-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Key Differentiating Features for "Insight Moments"</p>
                  <p>The following features would most strongly differentiate your executive micro-learning app from competitors:</p>
                  <p class="font-semibold">1. Smart Timing Engine</p>
                  <p>This algorithm that identifies optimal learning moments based on calendar analysis and user behavior patterns is revolutionary because:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Most learning platforms are passive and expect users to find time</li>
                    <li>This actively identifies micro-moments that would otherwise be lost</li>
                    <li>It respects executive time constraints in a way competitors don't</li>
                    <li>It transforms waiting time into productive learning opportunities</li>
                  </ul>
                   <p class="font-semibold">2. Context Matcher</p>
                  <p>Delivering content relevant to upcoming meetings, active projects, and recent work topics stands out because:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Competitors offer generic content libraries requiring manual searching</li>
                    <li>This creates "just-in-time" relevance that dramatically increases application</li>
                    <li>It eliminates the discovery friction that prevents busy executives from learning</li>
                    <li>It makes learning feel integrated with work rather than competing with it</li>
                  </ul>
                   <p class="font-semibold">2. Application Tracker</p>
                  <p>The simple interface to flag when insights influenced decisions is distinctive because:</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>Traditional platforms measure completion, not application</li>
                    <li>This connects learning directly to business impact</li>
                    <li>It provides meaningful ROI metrics executives care about</li>
                    <li>It creates a virtuous cycle of learning and application</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-orange-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 06 -->

      </div>
    </div>
    <!-- END / IDEATION BLOCK -->

    <!-- PROTOTYPING BLOCK -->
    <div class="space-y-4 p-6 border border-sky-300 rounded-xl dark:border-sky-100/40">
      <h3 class="text-xl mb-6 text-slate-700 dark:text-slate-300">Prototyping (5 steps)</h3>
      <div class="space-y-2">
        
        <!-- step 01 -->
        <ExpanderStep :step="'01'" :title="'User flows'" :icon="'🤖'" :style="'border-sky-300 bg-sky-200 hover:bg-sky-300'" :background="'bg-sky-100'" >
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-3 text-slate-700 text-lg">I ask the AI to create user flows for the described app. This will lay out path to be used by the AI later when creating the final prototype.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Create an user flow for learning platform to learn with the features we discussed.</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Core User Flow for "Insight Moments" Learning Platform</p>
                  <p>Dashboard entry</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li>User opens desktop app or widget becomes visible</li>
                    <li>Just-in-time learning: They want immediate access to relevant knowledge when facing specific challenges</li>
                    <li>System displays personalized dashboard showing:
                      <ul class="list-disc list-outside ml-5">
                        <li>Today's recommended insights (3-5 items)</li>
                        <li>Upcoming meeting-relevant content</li>
                        <li>Recently saved insights for quick reference</li>
                        <li>Learning impact metrics (simple visualization)</li>
                      </ul>
                    </li>
                  </ul>
                  <p>Calendar-Based Learning</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li>System detects upcoming meeting about "Logistics Automation"</li>
                    <li>Notification appears: "5-min prep for your Logistics Automation meeting"</li>
                    <li>User clicks notification to view curated insights</li>
                    <li>System presents 3 key points relevant to meeting topic</li>
                    <li>User consumes content in preferred format (text/audio/visual)</li>
                  </ul>
                  <p>Gap-Based Learning</p>
                  <ul class="list-decimal list-outside ml-5">
                    <li>System detects 15-minute gap between meetings</li>
                    <li>Notification: "Perfect time for a Focus Sprint on AI in Logistics"</li>
                    <li>User clicks to access structured micro-learning module</li>
                    <li>Content presented in sequential 3-5 minute segments</li>
                    <li>Progress automatically saves if interrupted by new task</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 01 -->

        <!-- step 02 -->
        <ExpanderStep :step="'02'" :title="'Narrow focus / one flow'" :icon="'🤖'" :style="'border-sky-300 bg-sky-200 hover:bg-sky-300'" :background="'bg-sky-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">One more time, ask the AI to focus in one single user flow. I also asked to shorten the initial answer “<i>Can you shorten the detailed interactions</i>? so I can use them to create a chart.”</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you expand more on Gap-Based Learning with focus on interactions for each point?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Gap-Based Learning Flow: Condensed Interactions</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>User: No action required</li>
                    <li>System: Analyzes calendar, selects optimal content, prepares delivery</li>
                  </ul>
                  <p class="font-semibold">Notification: "Perfect time for a Focus Sprint on AI in Logistics"</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>User: Click to accept, dismiss, snooze, or long-press for options</li>
                    <li>System: Responds based on selection (proceed, note pattern, reschedule, or show menu)</li>
                  </ul>
                  <p class="font-semibold">User clicks to access 10-minute structured learning module</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>User: Single click transitions to learning interface</li>
                    <li>System: Displays timer, progress indicator, format toggles, and minimize button)</li>
                  </ul>
                  <p class="font-semibold">Content presented in sequential 3-5 minute segments</p>
                  <ul class="list-disc list-outside ml-5">
                    <li>User: Consumes content, can highlight, expand concepts, adjust pace, or skip sections</li>
                    <li>System: Adapts remaining content based on interactions and time constraints</li>
                  </ul>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 02 -->

        <!-- step 03 -->
        <ExpanderStep :step="'03'" :title="'Flow chart'" :icon="'🤖'" :style="'border-sky-300 bg-sky-200 hover:bg-sky-300'" :background="'bg-sky-100'"> 
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">This step required a bit of workaround since Claude struggles to create visual charts. Then, I went with these <a href="https://mermaid.js.org/intro/syntax-reference.html" target="_blank" class="underline text-blue">mermaid syntax</a> into mermaid app to actually genearte a visual chart.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Can you generate <b>mermaid syntax</b> for Gap-based Learning Flow?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                <p class="font-semibold">Mermaid syntax</p>
                  <p>A[System detects 15-minute gap] -->|Prepares content| B[Notification appears]
    
                      B -->|Click to accept| C[Learning module opens]
                      B -->|Dismiss| Z[Return to work]
                      B -->|Snooze| Y[Schedule for later]
                      B -->|Long-press| X[Show options menu]
    
                      C -->|User engages| D[Content presented in segments]
                      
                      D -->|User interaction| D
                      D -->|Interruption| E[Progress auto-saves]
                      D -->|Completion| F[Offer application framework]
                </p>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1 ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>


              <!-- Mermaid flow-chart -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <a href="https://tinyurl.com/yk6xa5zd" target="_blank">
                    <img 
                    :src="imgSrc('assets/work-gallery/CS-AIUX-process/CS_AIUX_mermaid-chart.png')" 
                    alt="Mermaid flowchart showcasing user flows" 
                    class="max-w-[300px] w-full h-full object-cover rounded-xl cursor-pointer transition-transform duration-300 ease-out hover:scale-[1.02]">
                  </a>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🔀 Mermaid
                </div>
              </div>
              <!-- END Mermaid flow-chart -->
            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 03 -->

        <!-- step 04 -->
        <ExpanderStep :step="'04'" :title="'Storyboard'" :icon="'🤖'" :style="'border-sky-300 bg-sky-200 hover:bg-sky-300'" :background="'bg-sky-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">At this step I asked the AI to create a Storyboard script to then used into <a href="https://partyrock.aws/" target="_blank">PartyRock</a> application that creates storyboards.</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Based on the user flow you provided, can you create a Storyboard script about Sarah's Chen journey using the app you described?</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Storyboard Script: Sarah Chen's Learning Journey</p>
                  <p class="font-semibold">Scene 1: Morning Rush</p>
                  <p>Sarah checks her watch while gathering her things in a modern kitchen SARAH (V.O.): "As a Chief Strategy Officer, my biggest challenge isn't finding information—it's finding the right insights when I actually need them, in the small gaps between decisions."</p>
                  <p class="font-semibold">Scene 2: Calendar View</p>
                  <p>Close-up of Sarah's phone calendar showing back-to-back meetings SARAH (V.O.): "My day is a series of high-stakes meetings with barely a moment to breathe, let alone learn something new."</p>
                  <p class="font-semibold">Scene 3: Waiting for Rideshare</p>
                  <p>Sarah standing outside her office building, checking her phone NOTIFICATION: "15-minute gap detected. Perfect time for a Focus Sprint on 'AI in Logistics'" SARAH: Taps notification with interest</p>
                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

              <!-- PartyRock bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  
                  <div class="flex flex-col items-start gap-4 justify-center mb-4 md:flex-row">
                    <div class="flex-col space-y-2">
                      <img 
                      :src="imgSrc('assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_00.png')" 
                      alt="Sarah checks her watch while gathering her things in a modern kitchen" 
                      class="rounded-xl cursor-pointer transition-transform duration-300 ease-out hover:scale-[1.02]">

                      <h2 class="text-xs font-semibold text-slate-700 tracking-wide">
                        Scene 1: Morning Rush
                      </h2>

                      <p class="text-xs text-slate-700">
                        Sarah checks her watch while gathering her things in a modern kitchen.
                      </p>

                      <p class="text-xs text-slate-700 italic">
                        SARAH (V.O.): “As a Chief Strategy Officer, my biggest challenge isn’t
                        finding information—it’s finding the right insights when I actually need
                        them.”
                      </p>
                    </div>

                    <div class="flex-col space-y-2">
                      <img 
                      :src="imgSrc('assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_01.png')" 
                      alt="Close-up of Sarah's phone calendar showing back-to-back meetings" 
                      class="rounded-xl cursor-pointer transition-transform duration-300 ease-out hover:scale-[1.02]">

                      <h2 class="text-sm font-semibold text-slate-700 tracking-wide">
                        Scene 2: Calendar View
                      </h2>

                      <p class="text-xs text-slate-700">
                        Close-up of Sarah's phone calendar showing back-to-back meetings
                      </p>

                      <p class="text-xs text-slate-700 italic">SARAH (V.O.): "My day is a series of high-stakes meetings with barely a moment to breathe, let alone learn something new."</p>
                    </div>

                    <div class="flex-col space-y-2">
                      <img 
                      :src="imgSrc('assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_02.png')" 
                      alt="Sarah standing outside her office building, checking her phone" 
                      class="rounded-xl cursor-pointer transition-transform duration-300 ease-out hover:scale-[1.02]">

                      <h2 class="text-sm font-semibold text-slate-700 tracking-wide">
                        Scene 3: Waiting for Rideshare
                      </h2>

                      <p class="text-slate-700">Sarah standing outside her office building, checking her phone</p>

                      <p class="text-xs text-slate-700 italic">NOTIFICATION: "15-minute gap detected. Perfect time for a Focus Sprint on 'AI in Logistics'"</p>
                      <p class="text-xs text-slate-700 italic">SARAH: Taps notification with interest</p>
                    </div>
                  </div>


                  <p class="flex flew-wrap text-xs text-gray-600 leading-relaxed border-t border-indigo-900/40 py-2">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🦾 PartyRock
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 04 -->

        <!-- step 05 -->
        <ExpanderStep :step="'05'" :title="'Prototype'" :icon="'🛠️'" :style="'border-sky-300 bg-sky-200 hover:bg-sky-300'" :background="'bg-sky-100'">
          <div class="space-y-6">
            <p class="border-b border-indigo-900/10 pb-2 text-slate-700 text-lg">As final step, I used Figma Make to create a interactive prototype. This time I'm not only using a single instructional prompt but also adding references to Problem statement (Research, step 10) and Gap-learning based flow( Prototyping step 3).</p>
            <div class="space-y-4 px-2 lg:px-16">

              <!-- User bubble -->
              <div class="flex flex-col items-start gap-2 md:flex-row">
                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-white p-2 text-xs">👤 <span>User</span></div>

                <!-- Bubble -->
                <div class="w-full bg-white text-slate-800 px-4 py-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:max-w-[80%]">
                  <p>Create an interface product for the following case (<i>Research - step 10, Prototying - step 02</i>) by using Material design as design system.</p>
                </div>
              </div>

              <!-- AI bubble -->
              <div class="flex flex-col-reverse items-start gap-2 justify-end md:flex-row">
                <!-- Bubble -->
                <div class="w-full bg-sky-200 text-slate-900 px-4 py-2 space-y-2 rounded-xl rounded-tl-sm text-sm leading-relaxed md:rounded-tr-sm md:rounded-tl-xl md:max-w-[80%] ">
                  <p class="font-semibold">Reasoning</p>
                  <p>I'll create an executive learning interface using Material UI as the open-source design system. This will showcase the gap-based learning flow for busy executives like Sarah Chen.</p>
                  <p>I've created a comprehensive executive learning interface called "Focus Sprint AI" using Material UI as the open-source design system. The prototype demonstrates the complete gap-based learning flow with professional, polished components that match the needs of busy executives like Sarah Chen.</p>
                   <div class="p-0 md:p-4">
                    <a class="btn-green-primary flex flex-row items-start justify-center w-full md:max-w-[350px]" href="https://brave-shield-47656061.figma.site/" target="_blank" role="button">
                      <span class="text-xs md:text-sm">VIEW INTERACTIVE PROTOTYPE</span> <IconLink :name="'new_window'" :width="16" :height="16" :style="'new-window ml-1 mt-1'" />
                    </a>
                   </div> 




                  <p class="flex flex-wrap text-xs text-gray-600 leading-relaxed">See the full answer 
                    <a href="https://tinyurl.com/2vrs8866" target="_blank" class="inline-flex items-center gap-1 text-blue-600 hover:underline ml-1"> 
                      here (FigJam)
                      <IconLink :name="'new_window'" :width="12" :height="12" :style="'new-window'" />
                    </a>.
                  </p>
                </div>

                <!-- Avatar -->
                <div class="rounded-lg font-semibold bg-sky-200 p-2 text-xs">
                  🤖 Claude 3.7
                </div>
              </div>

            </div>
          </div>
        </ExpanderStep>
        <!-- END / Step 06 -->

      </div>
    </div>
    <!-- END / PROTOTYPING BLOCK -->


  </section>
  <!-- End/AIUX-process-section-->


  <!-- The results -->
  <section class="flex flex-col text-base leading-normal mx-auto max-w-6xl px-6 dark:slate-500 space-y-4 mb-20">
    <h2 class="text-2xl h-auto max-w-prose dark:text-white">The results</h2>
    <p class="mb-4 text-base text-slate-700 leading-relaxed dark:text-slate-300">
      After I completed this exploration, I hosted a small workshop with the team where I guided through the process. This brought clarity about <b>the AI and how does fit into design process</b>. It also gave them inspiration to the team to find new ways of applying the AI into work,  which was exactly the kind of momentum I hoped for. 
    </p>

    <p class="mb-4 text-base text-slate-700 leading-relaxed dark:text-slate-300">
      Products with highly ambiguous problems had the most from this kind of process. By using the AI as a co-designer, I was able to <b>quickly generate and iterate on ideas</b>, which helped to fill gaps on very early stages drive decision-making by providing a wider context. This has a real impact on presenting concepts and ideas to stakeholders: simulating enviroments and sythetic users has bring clarity when taking decisions.
    </p>
    
    <p class="text-base text-slate-700 leading-relaxed dark:text-slate-300">
    During the first three months of using the framework, I saw early results in my team and myself, like saving between <b>1-3 hours per project</b> by speeding the production of design assets and reducing redundant communications between teams.
    </p>

       <ul class="flex flex-wrap list-none items-start justify-start gap-4 mt-4">
          <li v-for="(button, idx) in $tm('caseStudies.CS_strategic-design.proposal-section.results.buttons')" :key="idx" class="flex flex-wrap items-center">
            <span class="h-auto">
              <router-link
                v-if="!isExternal(button.url)"
                :to="`/${$i18n.locale}`+ button.url"
                class="no-underline"
              >
                <button :class="`${button.style} rounded-xl text-sm`">{{button.text}}</button>
              </router-link>
              <a v-else :href="button.url" :aria-label="button.text" target="_blank" :class="`${button.style} rounded-xl text-sm`">{{button.text}}</a>
            </span>
          </li>
       </ul>
  </section>
  <!-- End/The results-->


  </div>
</template>

<script>
import ExpanderStep from '../components/expanderStep.vue';
import imageLauncherVue from '../components/imageLauncher.vue';
import {useI18n} from 'vue-i18n';
import IconLink from "../components/iconDisplay";

export default {
  name: "Contact-me",
  components: {
    ExpanderStep,
    IconLink,
    imageLauncherVue
  },
  methods: {
    isExternal(url) {
      // crude check: external if starts with http.
      // Used to determine what type of button to use (router-link vs link) .
      return /^https?:\/\//.test(url);
    }
  },
  computed: {
    // Computed properties are cached getters, not functions.
    // so we return a function to use parameters such fileName.
    imgSrc() {
      return (urlFile) => {
        try {
          return require(`../${urlFile}`);
        } catch (e) {
          return require("../assets/img-placeholder.jpg");
        }
      }
    },
  },
  setup() {
    const {t} = useI18n();

    const Openlink = {
        name: "new_window",
        w: 15,
        h: 15,
        style: 'new-window',
        link: "",
    }

    const assetImages = [
      {src: require('../assets/work-gallery/CS-AIUX-process/CS_AIUX_sarah_cheng_persona_profile.png'), alt: 'Synthetic persona profile for Sarah Cheng'},
      {src: require('../assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_combined_01.png'), alt: 'Storyboard showcasing conceptual scenes of the app in use'},
      {src: require('../assets/work-gallery/CS-AIUX-process/CS_AIUX_storyboard_combined_02.png'), alt: 'Storyboard showcasing conceptual scenes of the app in use'}
    ]

    return {t,Openlink, assetImages};
  },
};
</script>

<style lang="scss" scoped>
/* Open new window icon */
.new-window{
  svg {
    stroke: rgb(255, 4, 4);
  }
}
</style>
